export const PERFORMANCE_CALCULATION_KEYS = {
  CURRENT_FIXING_MINUS_COUPON_STRIKE: 'CURRENT_FIXING_MINUS_COUPON_STRIKE',
  FINAL_OVER_INITIAL: 'FINAL_OVER_INITIAL',
  FINAL_MINUS_INITIAL: 'FINAL_MINUS_INITIAL',
  FINAL: 'FINAL',
};

export const PERFORMANCE_CALCULATION_TYPES = [
  {
    id: PERFORMANCE_CALCULATION_KEYS.CURRENT_FIXING_MINUS_COUPON_STRIKE,
    displayValue: 'Current Fixing - Coupon Strike',
  },
  {
    id: PERFORMANCE_CALCULATION_KEYS.FINAL_OVER_INITIAL,
    displayValue: 'Final / Initial',
  },
  {
    id: PERFORMANCE_CALCULATION_KEYS.FINAL_MINUS_INITIAL,
    displayValue: 'Final - Initial',
  },
  { id: PERFORMANCE_CALCULATION_KEYS.FINAL, displayValue: 'Final' },
];
